class LmdNavigation extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.toggle = this.querySelector('.lmd-nav-toggle');
    this.panel = this.querySelector('.lmd-nav-panel');
    this.backdrop = this.querySelector('.lmd-nav-backdrop');
    this.scrollArea = this.querySelector('.lmd-nav-scroll');
    this.closeButton = this.querySelector('.lmd-nav-close');
    this.toggle.addEventListener('click', () => this.hasAttribute('data-open') ? this.close() : this.open());
    this.closeButton.addEventListener('click', () => this.close());
    this.backdrop.addEventListener('click', () => this.close());
    this.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
      if (detail.open) [...detail.parentElement.parentElement.children].forEach(item => {
        const sibling = item.querySelector(':scope > details');
        if (sibling && sibling !== detail) sibling.open = false;
      });
      this.save();
    }));
    this.addEventListener('keydown', event => {
      if (!this.hasAttribute('data-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.close(); }
      if (event.key === 'Tab') {
        const focusable = [...this.panel.querySelectorAll('a,button,input,summary')].filter(e => e.getClientRects().length && !e.disabled);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    this.panel.addEventListener('click', event => { if (event.target.closest('a')) this.save(true); });
    this.scrollArea.addEventListener('scroll', () => this.save(), {passive:true});
    this.resize = () => { if (this.hasAttribute('data-open')) this.setPosition(); };
    window.addEventListener('resize', this.resize);
    window.addEventListener('pageshow', () => {
      try { const state = JSON.parse(sessionStorage.getItem('lmd-navigation-state')); if (state && state.returning && state.path === location.pathname) this.open(true); } catch (_) {}
    });
  }
  setPosition() {
    const header = this.closest('.section-header') || this.closest('.header-wrapper');
    const bottom = Math.max(0, header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--lmd-nav-top', `${bottom}px`);
  }
  open(restore = false) {
    this.setAttribute('data-open',''); this.panel.hidden = false; this.backdrop.hidden = false;
    this.toggle.setAttribute('aria-expanded','true'); document.body.classList.add('lmd-menu-open');
    this.setPosition();
    if (restore) try {
      const state = JSON.parse(sessionStorage.getItem('lmd-navigation-state'));
      this.querySelectorAll('details').forEach(d => d.open = state.keys.includes(d.dataset.lmdKey));
      this.scrollArea.scrollTop = state.scroll || 0;
      state.returning = false; sessionStorage.setItem('lmd-navigation-state', JSON.stringify(state));
    } catch (_) {}
    this.closeButton.focus();
  }
  close() {
    this.save(); this.removeAttribute('data-open'); this.panel.hidden = true; this.backdrop.hidden = true;
    this.toggle.setAttribute('aria-expanded','false'); document.body.classList.remove('lmd-menu-open'); this.toggle.focus();
    try { sessionStorage.removeItem('lmd-navigation-state'); } catch (_) {}
  }
  save(returning = false) {
    if (!this.hasAttribute('data-open')) return;
    try { sessionStorage.setItem('lmd-navigation-state',JSON.stringify({path:location.pathname,keys:[...this.querySelectorAll('details[open]')].map(d=>d.dataset.lmdKey),scroll:this.scrollArea.scrollTop,returning})); } catch (_) {}
  }
}
if (!customElements.get('lmd-navigation')) customElements.define('lmd-navigation', LmdNavigation);
